import { __ } from "@common/helpers/i18n";
import { Spinner } from "./Spinner";

export function PaginationLoadingHint() {
  return (
    <div className="px-3 py-3">
      <div className="flex items-center gap-3 rounded-lg border border-border bg-muted/25 px-3 py-3 text-start text-muted-foreground">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Spinner size="sm" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-xs font-bold leading-5 text-foreground">
            {__("Loading more items")}
          </span>
          <span className="block text-mini font-medium leading-4 text-muted-foreground">
            {__("Please wait a moment.")}
          </span>
        </span>
      </div>
    </div>
  );
}
